import * as yup from "yup";
export const HighBandTaskSchema = {
    ten_doi_tuong_xu_ly: yup.string()
        .required("Tên đối tượng xử lý không được để trống") // bắt buộc nhập
        .matches(/^[A-Za-zÀ-ỹ\s]+$/, "Tên đối tượng xử lý chỉ được chứa chữ cái và khoảng trắng"),
    ma_nguoi_dat_lich: yup
        .string()
        .required("Mã người đặt lịch không được để trống")
        .matches(/^[0-9]+$/, "Mã người đặt lịch chỉ được chứa số"),
    sdt_doi_tuong_xu_ly: yup.string().required("Số điện thoại đối tượng xử lý không được để trống").matches(/^0[3-9][0-9]{8}$/, "Số điện thoại không đúng định dạng"),
    ma_nhan_su_nguoi_phu_trach: yup
        .string()
        .required("Mã nhân sự phụ trách không được để trống")
        .matches(/^[0-9]+$/, "Mã nhân sự phụ trách chỉ được chứa số"),
    trung_tam: yup.string().required("Trung tâm không được để trống"),
    co_so: yup.string().required("Cơ sở không được để trống"),
    ngay_lam: yup.string().required("Ngày làm không được để trống").matches(
            /^(0[1-9]|[12][0-9]|3[01])[-\/](0[1-9]|1[0-2])[-\/]\d{4}$/,
            "Ngày làm phải có định dạng DD/MM/YYYY"
        ),
    thoi_gian_bat_dau: yup.string().required("Thời gian bắt đầu không được để trống").matches(
        /^([01]\d|2[0-3]):([0-5]\d)$/,
        "Thời gian phải có định dạng HH:mm (00:00 - 23:59)"
    ),
    thoi_gian_ket_thuc: yup
        .string()
        .required("Thời gian kết thúc không được để trống")
        .matches(
            /^([01]\d|2[0-3]):([0-5]\d)$/,
            "Thời gian phải có định dạng HH:mm (00:00 - 23:59)"
        ),
    diem_speaking: yup
        .number()
        .typeError("Điểm Speaking phải là số")
        .required("Điểm Speaking không được để trống")
        .min(0, "Điểm Speaking không được nhỏ hơn 0")
        .max(9, "Điểm Speaking không được lớn hơn 9")
        .test(
            "is-half-step",
            "Điểm Speaking phải theo thang 0.5 (ví dụ: 6, 6.5, 7)",
            (value) => value !== undefined && (value * 2) % 1 === 0
        ),
    diem_writing: yup
        .string()
        .typeError("Điểm Writing phải là số")
        .required("Điểm Writing không được để trống")
        .min(0, "Điểm Writing không được nhỏ hơn 0")
        .max(9, "Điểm Writing không được lớn hơn 9")
        .test(
            "is-half-step",
            "Điểm Writing phải theo thang 0.5 (ví dụ: 6, 6.5, 7)",
            (value) => value !== undefined && (value * 2) % 1 === 0
        ),
    diem_tieu_chi_1_speaking_do_troi_chay_va_mach_lac: yup
        .string()
        .typeError("Điểm TC1 Speaking phải là số")
        .required("Điểm TC1 Speaking không được để trống")
        .min(0, "Điểm TC1 Speaking không được nhỏ hơn 0")
        .max(9, "Điểm TC1 Speaking không được lớn hơn 9"),
    diem_tieu_chi_2_speaking_von_tu: yup
        .string()
        .typeError("Điểm TC2 Speaking phải là số")
        .required("Điểm TC2 Speaking không được để trống")
        .min(0, "Điểm TC2 Speaking không được nhỏ hơn 0")
        .max(9, "Điểm TC2 Speaking không được lớn hơn 9"),
    diem_tieu_chi_3_speaking_do_da_dang_va_chinh_xac_cua_ngu_phap: yup
        .string()
        .typeError("Điểm TC3 Speaking phải là số")
        .required("Không được để trống")
        .min(0, "Không nhỏ hơn 0")
        .max(9, "Không lớn hơn 9"),

    diem_tieu_chi_4_speaking_phat_am: yup
        .string()
        .typeError("Điểm TC4 Speaking phải là số")
        .required("Không được để trống")
        .min(0, "Không nhỏ hơn 0")
        .max(9, "Không lớn hơn 9"),

    diem_tieu_chi_1_writing_dap_ung_yeu_cau_de_bai: yup
        .string()
        .typeError("Điểm TC1 Writing phải là số")
        .required("Không được để trống")
        .min(0, "Không nhỏ hơn 0")
        .max(9, "Không lớn hơn 9"),

    diem_tieu_chi_2_writing_do_mach_lac: yup
        .string()
        .typeError("Điểm TC2 Writing phải là số")
        .required("Không được để trống")
        .min(0, "Không nhỏ hơn 0")
        .max(9, "Không lớn hơn 9"),

    diem_tieu_chi_3_writing_tu_vung: yup
        .string()
        .typeError("Điểm TC3 Writing phải là số")
        .required("Không được để trống")
        .min(0, "Không nhỏ hơn 0")
        .max(9, "Không lớn hơn 9"),

    diem_tieu_chi_4_writing_ngu_phap: yup
        .string()
        .typeError("Điểm TC4 Writing phải là số")
        .required("Không được để trống")
        .min(0, "Không nhỏ hơn 0")
        .max(9, "Không lớn hơn 9"),
    nhan_xet_cu_the_tieu_chi_1_speaking_do_troi_chay_va_mach_lac: yup
        .string()
        .required("Nhận xét TC1 Speaking không được để trống"),

    nhan_xet_cu_the_tieu_chi_2_speaking_von_tu: yup
        .string()
        .required("Nhận xét TC2 Speaking không được để trống"),

    nhan_xet_cu_the_tieu_chi_3_speaking_do_da_dang_va_chinh_xac_cua_ngu_phap: yup
        .string()
        .required("Nhận xét TC3 Speaking không được để trống"),

    nhan_xet_cu_the_tieu_chi_4_speaking_phat_am: yup
        .string()
        .required("Nhận xét TC4 Speaking không được để trống"),

    nhan_xet_cu_the_tieu_chi_1_writing_dap_ung_yeu_cau_de_bai: yup
        .string()
        .required("Nhận xét TC1 Writing không được để trống"),

    nhan_xet_tieu_chi_2_writing: yup
        .string()
        .required("Nhận xét TC2 Writing không được để trống"),

    nhan_xet_tieu_chi_3_writing: yup
        .string()
        .required("Nhận xét TC3 Writing không được để trống"),

    nhan_xet_tieu_chi_4_writing: yup
        .string()
        .required("Nhận xét TC4 Writing không được để trống"),
    so_cau_dung_listening: yup
        .string()
        .required("Số câu đúng Listening không được để trống")
        .matches(/^\d+$/, "Số câu đúng Listening chỉ được chứa số"),
    so_cau_dung_reading: yup
        .string()
        .required("Số câu đúng Reading không được để trống")
        .matches(/^\d+$/, "Số câu đúng Reading chỉ được chứa số"),
    diem_listening: yup
        .string()
        .typeError("Điểm Listening phải là số")
        .required("Điểm Listening không được để trống")
        .min(0, "Điểm Listening không được nhỏ hơn 0")
        .max(9, "Điểm Listening không được lớn hơn 9")
        .test(
            "is-half-step",
            "Điểm Listening phải theo thang 0.5 (ví dụ: 6, 6.5, 7)",
            (value) => value !== undefined && (value * 2) % 1 === 0
        ),

    diem_reading: yup
        .string()
        .typeError("Điểm Reading phải là số")
        .required("Điểm Reading không được để trống")
        .min(0, "Điểm Reading không được nhỏ hơn 0")
        .max(9, "Điểm Reading không được lớn hơn 9")
        .test(
            "is-half-step",
            "Điểm Reading phải theo thang 0.5 (ví dụ: 6, 6.5, 7)",
            (value) => value !== undefined && (value * 2) % 1 === 0
        ),
    overall: yup
        .string()
        .required("Overall không được để trống")
        .matches(/^\d+$/, "Overall chỉ được chứa số"),
    ti_le_dao_van_cua_bai_viet: yup
        .number()
        .typeError("Không đúng định dạng, bạn phải tuân theo quy tắc (Bài viết Không dấu hiệu đạo văn = 0<br>" +
            "Dưới 20% = 1<br>" +
            "Từ 20% -> 30% = 2<br>" +
            "Từ 30% -> 50% = 3\<br>" +
            "Từ 50% trờ lên = 4 ")
        .required("Phương án xử lý không được để trống")
        .oneOf([0, 1, 2, 3, 4], "Không đúng định dạng, bạn phải tuân theo quy tắc (Bài viết Không dấu hiệu đạo văn = 0<br>" +
    "Dưới 20% = 1<br>" +
            "Từ 20% -> 30% = 2<br>" +
        "Từ 30% -> 50% = 3\<br>" +
        "Từ 50% trờ lên = 4 ")
        .when("bai_viet_co_dau_hieu_dao_van_khong", {
            is: "Không",
            then: (schema) =>
            schema.oneOf([0], "Không đúng định dạng, bạn phải tuân theo quy tắc (Bài viết Không dấu hiệu đạo văn = 0<br>" +
                "Dưới 20% = 1<br>" +
                "Từ 20% -> 30% = 2<br>" +
                "Từ 30% -> 50% = 3\<br>" +
                "Từ 50% trờ lên = 4 "),
        }),
    khoa_hoc_goi_y: yup
        .string()
        .required("Khóa học gợi ý không được để trống"),
    bai_viet_co_dau_hieu_dao_van_khong: yup.string()
        .required("Bài viết có dấu hiệu đạo văn không được để trống")
        .oneOf(['Có','Không'], "Dữ liệu trường Bài viết có dấu hiệu đạo văn không? sai định dạng. Chỉ nhập dạng text \"Có\"  và \"Không\" "),
}